export default "/assets/images/welcome-mila-and-breathe-easy.dcb693d24d83a4b8.webp";